import { axiosInstance } from "@/pages/auth/auth.context";
import { JournalEntryDTO, JournalEntryRequest } from "@/types/journalEntry";
import { PageResponse } from "@/types/page";

export interface JournalEntryQuery {
  eventId?: string;
  /** True for only the notes admins left themselves, false for only bid notes. */
  standalone?: boolean;
  search?: string;
  createdFrom?: string; // yyyy-MM-dd
  createdTo?: string; // yyyy-MM-dd
  page?: number;
  size?: number;
}

export const journalEntryService = {
  list: async (
    query: JournalEntryQuery = {},
  ): Promise<PageResponse<JournalEntryDTO>> => {
    const params: Record<string, string | number> = {};
    if (query.eventId) params.eventId = query.eventId;
    if (query.standalone != null) params.standalone = String(query.standalone);
    if (query.search) params.search = query.search;
    if (query.createdFrom) params.createdFrom = query.createdFrom;
    if (query.createdTo) params.createdTo = query.createdTo;
    if (query.page != null) params.page = query.page;
    if (query.size != null) params.size = query.size;

    const res = await axiosInstance.get<PageResponse<JournalEntryDTO>>(
      "journal-entries",
      { params },
    );
    return res.data;
  },

  create: async (req: JournalEntryRequest): Promise<JournalEntryDTO> => {
    const res = await axiosInstance.post<JournalEntryDTO>(
      "journal-entries",
      req,
    );
    return res.data;
  },

  update: async (
    id: string,
    req: Omit<JournalEntryRequest, "eventId">,
  ): Promise<JournalEntryDTO> => {
    const res = await axiosInstance.put<JournalEntryDTO>(
      `journal-entries/${id}`,
      req,
    );
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await axiosInstance.delete(`journal-entries/${id}`);
  },
};
